
import $ from 'jquery'

export default function () {
  var $link = $('.link--answer')
  var form = '.section-family__condolences__item__form'

  $link.click(function (e) {
    e.preventDefault()
    $(this).parent().next(form).fadeToggle()
  })
}



// WEBPACK FOOTER //
// ./scripts/lib/family-answer.js